import { GlobalFunctionName } from '../utils/nativeBridge'
import LocalStorageManager from './LocalStorageManager'

const NativePrefix = 'BAEMIN_MARKET'

const NativeStorageKey = Object.freeze({
  BAEMIN_MARKET_DELETED_ORDER_ID: `${NativePrefix}_DELETED_ORDER_ID`,
  BAEMIN_SHOP_NO: `${NativePrefix}_BAEMIN_SHOP_NO`,
  ACCESS_TOKEN: `${NativePrefix}_ACCESS_TOKEN`,
  KEY: `${NativePrefix}_KEY`,
  SESSION_ID: `${NativePrefix}_SESSION_ID`,

  APPSFLYER_AFID: `${NativePrefix}_APPSFLYER_AFID`,
  APPSFLYER_ADID: `${NativePrefix}_APPSFLYER_ADID`,

  GO_TO_BMART_FLAG: `${NativePrefix}_GO_TO_BMART_FLAG`,
  GO_TO_HOME_FLAG: `${NativePrefix}_GO_TO_HOME_FLAG`
})

const setGlobalFunction = (name, callback) => {
  if (typeof callback !== 'function') return
  window[name] = callback
}

const NativeStorageManager = class {
  constructor() {
    this._storage = window.JavaScriptInterface // ref. https://wiki.woowa.in/display/BMAPPDEV/Webview+javascript+interface
    this.localStorageManager = new LocalStorageManager()
  }

  get unavailable() {
    return !this._storage
  }

  get(key) {
    return new Promise((resolve, reject) => {
      if (!this._storage || !this._storage.getValue) {
        resolve(this.localStorageManager.get(key))
        return
      }

      const nativeGetFunction = (result) => {
        resolve(result)
      }
      let functionName = `GET_CALLBACK_${key}`
      setGlobalFunction(functionName, nativeGetFunction)
      this._storage.getValue(key, functionName)
    })
  }

  set(key, value) {
    return new Promise((resolve, reject) => {
      if (!this._storage || !this._storage.setValue) {
        this.localStorageManager.set(key, value)
      } else {
        this._storage.setValue(key, value)
      }
      resolve()
    })
  }

  remove(key) {
    return new Promise((resolve, reject) => {
      if (!this._storage || !this._storage.setValue) {
        this.localStorageManager.remove(key)
      } else {
        this._storage.removeValue(key)
      }
      resolve()
    })
  }
}

export { NativeStorageKey }

export default NativeStorageManager
